export default {
  motability_awareness: {
    type: "likert",
    label: "Awareness of Motability Scheme",
    category: "motability",
    fulltext: "Have you heard of the Motability Scheme before today?",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "motability_aware_great_deal_motability_awareness",
      "motability_aware_fair_amount_motability_awareness",
      "motability_aware_heard_dont_know_much_motability_awareness",
      "motability_aware_heard_know_nothing_motability_awareness",
      "motability_aware_never_heard_motability_awareness",
      "motability_aware_DK_awareness"
    ],
    labels: {
      "motability_aware_great_deal_motability_awareness": "Yes, know a great deal",
      "motability_aware_fair_amount_motability_awareness": "Yes, know a fair amount",
      "motability_aware_heard_dont_know_much_motability_awareness": "Heard of it, don't know much",
      "motability_aware_heard_know_nothing_motability_awareness": "Heard the name, know nothing",
      "motability_aware_never_heard_motability_awareness": "Never heard of it",
      "motability_aware_DK_awareness": "Don't know"
    },
    colors: {
      "motability_aware_great_deal_motability_awareness": "#1B5E20",
      "motability_aware_fair_amount_motability_awareness": "#388E3C",
      "motability_aware_heard_dont_know_much_motability_awareness": "#F57F17",
      "motability_aware_heard_know_nothing_motability_awareness": "#E53935",
      "motability_aware_never_heard_motability_awareness": "#B71C1C",
      "motability_aware_DK_awareness": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_aware_great_deal_motability_awareness", "motability_aware_fair_amount_motability_awareness"],
      neu: "motability_aware_heard_dont_know_much_motability_awareness",
      neg: ["motability_aware_heard_know_nothing_motability_awareness", "motability_aware_never_heard_motability_awareness"],
      dk: "motability_aware_DK_awareness"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  motability_view: {
    type: "likert",
    label: "General view of Motability Scheme",
    category: "motability",
    fulltext: "Overall, what is your general view of the Motability Scheme?",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "motability_view_very_positive_motability_view",
      "motability_view_fairly_positive_motability_view",
      "motability_view_neither_motability_view",
      "motability_view_fairly_negative_motability_view",
      "motability_view_very_negative_motability_view",
      "motability_view_DK_motability_view"
    ],
    labels: {
      "motability_view_very_positive_motability_view": "Very positive",
      "motability_view_fairly_positive_motability_view": "Fairly positive",
      "motability_view_neither_motability_view": "Neither positive nor negative",
      "motability_view_fairly_negative_motability_view": "Fairly negative",
      "motability_view_very_negative_motability_view": "Very negative",
      "motability_view_DK_motability_view": "Don't know"
    },
    colors: {
      "motability_view_very_positive_motability_view": "#2E7D32",
      "motability_view_fairly_positive_motability_view": "#66BB6A",
      "motability_view_neither_motability_view": "#6B7280",
      "motability_view_fairly_negative_motability_view": "#EF5350",
      "motability_view_very_negative_motability_view": "#C62828",
      "motability_view_DK_motability_view": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_view_very_positive_motability_view", "motability_view_fairly_positive_motability_view"],
      neu: "motability_view_neither_motability_view",
      neg: ["motability_view_fairly_negative_motability_view", "motability_view_very_negative_motability_view"],
      dk: "motability_view_DK_motability_view"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  trust_motability: {
    type: "likert_grid",
    label: "Trust in Motability Scheme",
    netLabel: "trust in the scheme",
    fulltext: "To what degree would you say you trust the Motability Scheme to....",
    sidebarCompareSubtitle: "Compare net trust across all aspects, or drill into one.",
    sidebarCompareButton: "Compare all aspects",
    sidebarDrillTitle: "Drill into an aspect",
    sidebarDrillSubtitle: "Select an aspect for individual results.",
    sidebarDrillSubtitleTarget: "Select one aspect trust score for targeting.",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    subVariables: [
      "motability_trust_disabled_interests",
      "motability_trust_taxpayer_value",
      "motability_trust_effective_service",
      "motability_trust_manage_taxpayers",
      "motability_trust_interests_carers",
    ],
    subLabels: {
      "motability_trust_disabled_interests": "Act in best interests of disabled people",
      "motability_trust_taxpayer_value":     "Provide value for taxpayers' money",
      "motability_trust_effective_service":  "Deliver an effective service",
      "motability_trust_manage_taxpayers":   "Manage taxpayers' money responsibly",
      "motability_trust_interests_carers":   "Act in best interests of carers and families",
    },
    subColors: {
      "motability_trust_disabled_interests": "#1565C0",
      "motability_trust_taxpayer_value":     "#2E7D32",
      "motability_trust_effective_service":  "#F57C00",
      "motability_trust_manage_taxpayers":   "#7B1FA2",
      "motability_trust_interests_carers":   "#0097A7",
    },
    // Flat union of all sub-variable keys — used by fetchMetrics to request all trust data
    keys: [
      "motability_trust_disabled_interests_trust_great_deal_motability", "motability_trust_disabled_interests_trust_fair_amount_motabilit", "motability_trust_disabled_interests_neither_motability_trust_di", "motability_trust_disabled_interests_distrust_somewhat_motabilit", "motability_trust_disabled_interests_distrust_great_deal_motabil", "motability_trust_disabled_interests_DK_motability_trust_disable",
      "motability_trust_taxpayer_value_trust_great_deal_motability_tru", "motability_trust_taxpayer_value_trust_fair_amount_motability_tr", "motability_trust_taxpayer_value_neither_motability_trust_taxpay", "motability_trust_taxpayer_value_distrust_somewhat_motability_tr", "motability_trust_taxpayer_value_distrust_great_deal_motability_", "motability_trust_taxpayer_value_DK_motability_trust_taxpayer_va",
      "motability_trust_effective_service_trust_great_deal_motability_", "motability_trust_effective_service_trust_fair_amount_motability", "motability_trust_effective_service_neither_motability_trust_eff", "motability_trust_effective_service_distrust_somewhat_motability", "motability_trust_effective_service_distrust_great_deal_motabili", "motability_trust_effective_service_DK_motability_trust_effectiv",
      "motability_trust_manage_taxpayers_trust_great_deal_motability_t", "motability_trust_manage_taxpayers_trust_fair_amount_motability_", "motability_trust_manage_taxpayers_neither_motability_trust_mana", "motability_trust_manage_taxpayers_distrust_somewhat_motability_", "motability_trust_manage_taxpayers_distrust_great_deal_motabilit", "motability_trust_manage_taxpayers_DK_motability_trust_manage_ta",
      "motability_trust_interests_carers_trust_great_deal_motability_t", "motability_trust_interests_carers_trust_fair_amount_motability_", "motability_trust_interests_carers_neither_motability_trust_inte", "motability_trust_interests_carers_distrust_somewhat_motability_", "motability_trust_interests_carers_distrust_great_deal_motabilit", "motability_trust_interests_carers_DK_motability_trust_interests",
    ],
    labels: {},
    schema: "tracking",
    waves: [4, 5],
  },
 
  motability_trust_disabled_interests: {
    type: "likert",
    label: "Trust: act in best interests of disabled people",
    category: "motability",
    fulltext: "To what degree would you say you trust the Motability Scheme to act in the best interests of disabled people?",
    client: ["motability-operations", "stack-data-strategy"],
    hidden: true,
    keys: [
      "motability_trust_disabled_interests_trust_great_deal_motability",
      "motability_trust_disabled_interests_trust_fair_amount_motabilit",
      "motability_trust_disabled_interests_neither_motability_trust_di",
      "motability_trust_disabled_interests_distrust_somewhat_motabilit",
      "motability_trust_disabled_interests_distrust_great_deal_motabil",
      "motability_trust_disabled_interests_DK_motability_trust_disable"
    ],
    labels: {
      "motability_trust_disabled_interests_trust_great_deal_motability": "Trust a great deal",
      "motability_trust_disabled_interests_trust_fair_amount_motabilit": "Trust a fair amount",
      "motability_trust_disabled_interests_neither_motability_trust_di": "Neither trust nor distrust",
      "motability_trust_disabled_interests_distrust_somewhat_motabilit": "Distrust somewhat",
      "motability_trust_disabled_interests_distrust_great_deal_motabil": "Distrust a great deal",
      "motability_trust_disabled_interests_DK_motability_trust_disable": "Don't know"
    },
    colors: {
      "motability_trust_disabled_interests_trust_great_deal_motability": "#2E7D32",
      "motability_trust_disabled_interests_trust_fair_amount_motabilit": "#66BB6A",
      "motability_trust_disabled_interests_neither_motability_trust_di": "#6B7280",
      "motability_trust_disabled_interests_distrust_somewhat_motabilit": "#EF5350",
      "motability_trust_disabled_interests_distrust_great_deal_motabil": "#C62828",
      "motability_trust_disabled_interests_DK_motability_trust_disable": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_trust_disabled_interests_trust_great_deal_motability", "motability_trust_disabled_interests_trust_fair_amount_motabilit"],
      neu: "motability_trust_disabled_interests_neither_motability_trust_di",
      neg: ["motability_trust_disabled_interests_distrust_somewhat_motabilit", "motability_trust_disabled_interests_distrust_great_deal_motabil"],
      dk: "motability_trust_disabled_interests_DK_motability_trust_disable"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  motability_trust_taxpayer_value: {
    type: "likert",
    label: "Trust: provide value for taxpayers money",
    category: "motability",
    fulltext: "To what degree would you say you trust the Motability Scheme to provide value for taxpayers money in the service it provides?",
    client: ["motability-operations", "stack-data-strategy"],
    hidden: true,
    keys: [
      "motability_trust_taxpayer_value_trust_great_deal_motability_tru",
      "motability_trust_taxpayer_value_trust_fair_amount_motability_tr",
      "motability_trust_taxpayer_value_neither_motability_trust_taxpay",
      "motability_trust_taxpayer_value_distrust_somewhat_motability_tr",
      "motability_trust_taxpayer_value_distrust_great_deal_motability_",
      "motability_trust_taxpayer_value_DK_motability_trust_taxpayer_va"
    ],
    labels: {
      "motability_trust_taxpayer_value_trust_great_deal_motability_tru": "Trust a great deal",
      "motability_trust_taxpayer_value_trust_fair_amount_motability_tr": "Trust a fair amount",
      "motability_trust_taxpayer_value_neither_motability_trust_taxpay": "Neither trust nor distrust",
      "motability_trust_taxpayer_value_distrust_somewhat_motability_tr": "Distrust somewhat",
      "motability_trust_taxpayer_value_distrust_great_deal_motability_": "Distrust a great deal",
      "motability_trust_taxpayer_value_DK_motability_trust_taxpayer_va": "Don't know"
    },
    colors: {
      "motability_trust_taxpayer_value_trust_great_deal_motability_tru": "#2E7D32",
      "motability_trust_taxpayer_value_trust_fair_amount_motability_tr": "#66BB6A",
      "motability_trust_taxpayer_value_neither_motability_trust_taxpay": "#6B7280",
      "motability_trust_taxpayer_value_distrust_somewhat_motability_tr": "#EF5350",
      "motability_trust_taxpayer_value_distrust_great_deal_motability_": "#C62828",
      "motability_trust_taxpayer_value_DK_motability_trust_taxpayer_va": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_trust_taxpayer_value_trust_great_deal_motability_tru", "motability_trust_taxpayer_value_trust_fair_amount_motability_tr"],
      neu: "motability_trust_taxpayer_value_neither_motability_trust_taxpay",
      neg: ["motability_trust_taxpayer_value_distrust_somewhat_motability_tr", "motability_trust_taxpayer_value_distrust_great_deal_motability_"],
      dk: "motability_trust_taxpayer_value_DK_motability_trust_taxpayer_va"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  motability_trust_effective_service: {
    type: "likert",
    label: "Trust: deliver an effective service",
    category: "motability",
    fulltext: "To what degree would you say you trust the Motability Scheme to deliver an effective service?",
    client: ["motability-operations", "stack-data-strategy"],
    hidden: true,
    keys: [
      "motability_trust_effective_service_trust_great_deal_motability_",
      "motability_trust_effective_service_trust_fair_amount_motability",
      "motability_trust_effective_service_neither_motability_trust_eff",
      "motability_trust_effective_service_distrust_somewhat_motability",
      "motability_trust_effective_service_distrust_great_deal_motabili",
      "motability_trust_effective_service_DK_motability_trust_effectiv"
    ],
    labels: {
      "motability_trust_effective_service_trust_great_deal_motability_": "Trust a great deal",
      "motability_trust_effective_service_trust_fair_amount_motability": "Trust a fair amount",
      "motability_trust_effective_service_neither_motability_trust_eff": "Neither trust nor distrust",
      "motability_trust_effective_service_distrust_somewhat_motability": "Distrust somewhat",
      "motability_trust_effective_service_distrust_great_deal_motabili": "Distrust a great deal",
      "motability_trust_effective_service_DK_motability_trust_effectiv": "Don't know"
    },
    colors: {
      "motability_trust_effective_service_trust_great_deal_motability_": "#2E7D32",
      "motability_trust_effective_service_trust_fair_amount_motability": "#66BB6A",
      "motability_trust_effective_service_neither_motability_trust_eff": "#6B7280",
      "motability_trust_effective_service_distrust_somewhat_motability": "#EF5350",
      "motability_trust_effective_service_distrust_great_deal_motabili": "#C62828",
      "motability_trust_effective_service_DK_motability_trust_effectiv": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_trust_effective_service_trust_great_deal_motability_", "motability_trust_effective_service_trust_fair_amount_motability"],
      neu: "motability_trust_effective_service_neither_motability_trust_eff",
      neg: ["motability_trust_effective_service_distrust_somewhat_motability", "motability_trust_effective_service_distrust_great_deal_motabili"],
      dk: "motability_trust_effective_service_DK_motability_trust_effectiv"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  motability_trust_manage_taxpayers: {
    type: "likert",
    label: "Trust: manage taxpayers money responsibly",
    category: "motability",
    fulltext: "To what degree would you say you trust the Motability Scheme to manage taxpayers money responsibly?",
    client: ["motability-operations", "stack-data-strategy"],
    hidden: true,
    keys: [
      "motability_trust_manage_taxpayers_trust_great_deal_motability_t",
      "motability_trust_manage_taxpayers_trust_fair_amount_motability_",
      "motability_trust_manage_taxpayers_neither_motability_trust_mana",
      "motability_trust_manage_taxpayers_distrust_somewhat_motability_",
      "motability_trust_manage_taxpayers_distrust_great_deal_motabilit",
      "motability_trust_manage_taxpayers_DK_motability_trust_manage_ta"
    ],
    labels: {
      "motability_trust_manage_taxpayers_trust_great_deal_motability_t": "Trust a great deal",
      "motability_trust_manage_taxpayers_trust_fair_amount_motability_": "Trust a fair amount",
      "motability_trust_manage_taxpayers_neither_motability_trust_mana": "Neither trust nor distrust",
      "motability_trust_manage_taxpayers_distrust_somewhat_motability_": "Distrust somewhat",
      "motability_trust_manage_taxpayers_distrust_great_deal_motabilit": "Distrust a great deal",
      "motability_trust_manage_taxpayers_DK_motability_trust_manage_ta": "Don't know"
    },
    colors: {
      "motability_trust_manage_taxpayers_trust_great_deal_motability_t": "#2E7D32",
      "motability_trust_manage_taxpayers_trust_fair_amount_motability_": "#66BB6A",
      "motability_trust_manage_taxpayers_neither_motability_trust_mana": "#6B7280",
      "motability_trust_manage_taxpayers_distrust_somewhat_motability_": "#EF5350",
      "motability_trust_manage_taxpayers_distrust_great_deal_motabilit": "#C62828",
      "motability_trust_manage_taxpayers_DK_motability_trust_manage_ta": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_trust_manage_taxpayers_trust_great_deal_motability_t", "motability_trust_manage_taxpayers_trust_fair_amount_motability_"],
      neu: "motability_trust_manage_taxpayers_neither_motability_trust_mana",
      neg: ["motability_trust_manage_taxpayers_distrust_somewhat_motability_", "motability_trust_manage_taxpayers_distrust_great_deal_motabilit"],
      dk: "motability_trust_manage_taxpayers_DK_motability_trust_manage_ta"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  motability_trust_interests_carers: {
    type: "likert",
    label: "Trust: act in best interests of carers and families",
    category: "motability",
    fulltext: "To what degree would you say you trust the Motability Scheme to act in the best interests of carers and families of disabled people?",
    client: ["motability-operations", "stack-data-strategy"],
    hidden: true,
    keys: [
      "motability_trust_interests_carers_trust_great_deal_motability_t",
      "motability_trust_interests_carers_trust_fair_amount_motability_",
      "motability_trust_interests_carers_neither_motability_trust_inte",
      "motability_trust_interests_carers_distrust_somewhat_motability_",
      "motability_trust_interests_carers_distrust_great_deal_motabilit",
      "motability_trust_interests_carers_DK_motability_trust_interests"
    ],
    labels: {
      "motability_trust_interests_carers_trust_great_deal_motability_t": "Trust a great deal",
      "motability_trust_interests_carers_trust_fair_amount_motability_": "Trust a fair amount",
      "motability_trust_interests_carers_neither_motability_trust_inte": "Neither trust nor distrust",
      "motability_trust_interests_carers_distrust_somewhat_motability_": "Distrust somewhat",
      "motability_trust_interests_carers_distrust_great_deal_motabilit": "Distrust a great deal",
      "motability_trust_interests_carers_DK_motability_trust_interests": "Don't know"
    },
    colors: {
      "motability_trust_interests_carers_trust_great_deal_motability_t": "#2E7D32",
      "motability_trust_interests_carers_trust_fair_amount_motability_": "#66BB6A",
      "motability_trust_interests_carers_neither_motability_trust_inte": "#6B7280",
      "motability_trust_interests_carers_distrust_somewhat_motability_": "#EF5350",
      "motability_trust_interests_carers_distrust_great_deal_motabilit": "#C62828",
      "motability_trust_interests_carers_DK_motability_trust_interests": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_trust_interests_carers_trust_great_deal_motability_t", "motability_trust_interests_carers_trust_fair_amount_motability_"],
      neu: "motability_trust_interests_carers_neither_motability_trust_inte",
      neg: ["motability_trust_interests_carers_distrust_somewhat_motability_", "motability_trust_interests_carers_distrust_great_deal_motabilit"],
      dk: "motability_trust_interests_carers_DK_motability_trust_interests"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  motability_view_detailed: {
    type: "categorical",
    label: "Detailed view of Motability Scheme",
    category: "motability",
    fulltext: "Thinking about the Motability Scheme specifically, which of the following best describes your view?",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "motability_detailed_view_expanded_motability_view_detailed",
      "motability_detailed_view_maintained_motability_view_detailed",
      "motability_detailed_view_broad_support_motability_view_detailed",
      "motability_detailed_view_no_strong_view_motability_view_detaile",
      "motability_detailed_view_some_concerns_motability_view_detailed",
      "motability_detailed_view_sceptical_motability_view_detailed",
      "motability_detailed_view_abolished_motability_view_detailed",
      "motability_detailed_view_DK_motability_view_detailed"
    ],
    labels: {
      "motability_detailed_view_expanded_motability_view_detailed": "Strongly support — should be expanded",
      "motability_detailed_view_maintained_motability_view_detailed": "Support — maintain as is",
      "motability_detailed_view_broad_support_motability_view_detailed": "Broadly support — some aspects could improve",
      "motability_detailed_view_no_strong_view_motability_view_detaile": "No strong views either way",
      "motability_detailed_view_some_concerns_motability_view_detailed": "Some concerns — needs changes",
      "motability_detailed_view_sceptical_motability_view_detailed": "Sceptical — significant reform needed",
      "motability_detailed_view_abolished_motability_view_detailed": "Should be abolished",
      "motability_detailed_view_DK_motability_view_detailed": "Don't know"
    },
    colors: {
      "motability_detailed_view_expanded_motability_view_detailed": "#1739e5",
      "motability_detailed_view_maintained_motability_view_detailed": "#0288D1",
      "motability_detailed_view_broad_support_motability_view_detailed": "#00897B",
      "motability_detailed_view_no_strong_view_motability_view_detaile": "#9E9E9E",
      "motability_detailed_view_some_concerns_motability_view_detailed": "#F9A825",
      "motability_detailed_view_sceptical_motability_view_detailed": "#E64A19",
      "motability_detailed_view_abolished_motability_view_detailed": "#C62828",
      "motability_detailed_view_DK_motability_view_detailed": "#D0D0D0"
    },
    schema: "tracking",
    waves: [4, 5]
  },
 
  // Wave 4 only — no post-stimulus view question in the June 2026 questionnaire.
  motability_view_informed: {
    type: "likert",
    label: "General view of Motability Scheme (post-stimulus)",
    category: "motability",
    fulltext: "Given all that you have read, what is your general view of the Motability Scheme?",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "motability_view_informed_very_positive_motability_view_informed",
      "motability_view_informed_fairly_positive_motability_view_inform",
      "motability_view_informed_neither_motability_view_informed",
      "motability_view_informed_fairly_negative_motability_view_inform",
      "motability_view_informed_very_negative_motability_view_informed",
      "motability_view_informed_DK_motability_view_informed"
    ],
    labels: {
      "motability_view_informed_very_positive_motability_view_informed": "Very positive",
      "motability_view_informed_fairly_positive_motability_view_inform": "Fairly positive",
      "motability_view_informed_neither_motability_view_informed": "Neither positive nor negative",
      "motability_view_informed_fairly_negative_motability_view_inform": "Fairly negative",
      "motability_view_informed_very_negative_motability_view_informed": "Very negative",
      "motability_view_informed_DK_motability_view_informed": "Don't know"
    },
    colors: {
      "motability_view_informed_very_positive_motability_view_informed": "#2E7D32",
      "motability_view_informed_fairly_positive_motability_view_inform": "#66BB6A",
      "motability_view_informed_neither_motability_view_informed": "#6B7280",
      "motability_view_informed_fairly_negative_motability_view_inform": "#EF5350",
      "motability_view_informed_very_negative_motability_view_informed": "#C62828",
      "motability_view_informed_DK_motability_view_informed": "#B0B8C4"
    },
    polarity: {
      pos: ["motability_view_informed_very_positive_motability_view_informed", "motability_view_informed_fairly_positive_motability_view_inform"],
      neu: "motability_view_informed_neither_motability_view_informed",
      neg: ["motability_view_informed_fairly_negative_motability_view_inform", "motability_view_informed_very_negative_motability_view_informed"],
      dk: "motability_view_informed_DK_motability_view_informed"
    },
    schema: "tracking",
    waves: [4]
  },
 
  // Wave 4 only — not asked in June 2026.
  tradeoff_money: {
    type: "categorical",
    label: "Tradeoff: protect support vs return to Treasury",
    category: "motability",
    fulltext: "Which of the following comes closer to your view, even if neither describes it perfectly? It is more important to protect strong support for disabled people, even if that means less money goes back to the Treasury / It is more important to return more money to the Treasury, even if that means the Scheme becomes less generous",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "tradeoff_money_protect_support",
      "tradeoff_money_return_to_treasury"
    ],
    labels: {
      "tradeoff_money_protect_support": "Protect strong support for disabled people",
      "tradeoff_money_return_to_treasury": "Return more money to the Treasury"
    },
    colors: {
      "tradeoff_money_protect_support": "#1739e5",
      "tradeoff_money_return_to_treasury": "#FF6D00"
    },
    polarity: {
      pos: "tradeoff_money_protect_support",
      neg: "tradeoff_money_return_to_treasury"
    },
    schema: "tracking",
    waves: [4]
  },
 
  // Wave 5 data arrives here via the rename of motability_tradeoff_w2_*:
  //   harder_access -> tradeoff_access_tighten_access
  //   easier_access -> tradeoff_access_dont_tighten_access
  tradeoff_access: {
    type: "categorical",
    label: "Tradeoff: ease of access vs tightening rules",
    category: "motability",
    fulltext: "Which of the following comes closer to your view, even if it is not exactly right? It is better to make the Scheme easy for eligible people to access, even if there is some risk of misuse / It is better to tighten access rules to reduce misuse, even if some eligible people find access harder",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "tradeoff_access_dont_tighten_access",
      "tradeoff_access_tighten_access"
    ],
    labels: {
      "tradeoff_access_dont_tighten_access": "Keep the Scheme easy to access",
      "tradeoff_access_tighten_access": "Tighten access rules to reduce misuse"
    },
    colors: {
      "tradeoff_access_dont_tighten_access": "#1739e5",
      "tradeoff_access_tighten_access": "#FF6D00"
    },
    polarity: {
      pos: "tradeoff_access_dont_tighten_access",
      neg: "tradeoff_access_tighten_access"
    },
    schema: "tracking",
    waves: [4, 5]
  },


    tradeoff_access2: {
    type: "categorical",
    label: "Tradeoff: easier access vs harder access",
    category: "motability",
    fulltext: "Which of the following comes closer to your view, even if it is not exactly right? It is better to make the Scheme easy for people to access, even if there is some risk of people accessing the Scheme who shouldn’t be able to./It is better to make the Scheme harder for people to access, even if there is a risk some people who should have access aren't able to use the Scheme.",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "tradeoff_access_dont_tighten_access",
      "tradeoff_access_tighten_access"
    ],
    labels: {
      "tradeoff_access_dont_tighten_access": "Make the Scheme easier to access",
      "tradeoff_access_tighten_access": "Make the Scheme harder to access"
    },
    colors: {
      "tradeoff_access_dont_tighten_access": "#1739e5",
      "tradeoff_access_tighten_access": "#FF6D00"
    },
    polarity: {
      pos: "tradeoff_access_dont_tighten_access",
      neg: "tradeoff_access_tighten_access"
    },
    schema: "tracking",
    waves: [4, 5]
  },
  // Wave 4 only — not asked in June 2026.
  tradeoff_surplus: {
    type: "categorical",
    label: "Tradeoff: reinvest surplus vs return to Treasury",
    category: "motability",
    fulltext: "Which of the following comes closer to your view, even if it is not exactly right? Any financial surplus from the Motability Scheme should mainly be reinvested into support for disabled people / Any financial surplus from the Motability Scheme should mainly be returned to the Treasury",
    client: ["motability-operations", "stack-data-strategy"],
    keys: [
      "tradeoff_surplus_reinvest_disabled",
      "tradeoff_surplus_return_treasury"
    ],
    labels: {
      "tradeoff_surplus_reinvest_disabled": "Reinvest surplus into support for disabled people",
      "tradeoff_surplus_return_treasury": "Return surplus to the Treasury"
    },
    colors: {
      "tradeoff_surplus_reinvest_disabled": "#1739e5",
      "tradeoff_surplus_return_treasury": "#FF6D00"
    },
    polarity: {
      pos: "tradeoff_surplus_reinvest_disabled",
      neg: "tradeoff_surplus_return_treasury"
    },
    schema: "tracking",
    waves: [4]
  },
 
  // =========================================================================
  // MOTABILITY MESSAGE TESTING — GRID (parent)
  //
  // 9 statements from Q2.9 (June 2026). Three carry Wave-4 column names after
  // the rename and so run [4, 5]; six are new and run [5].
  // standing_up and treasury_deal were not asked in June 2026 and are
  // commented out below.
  // =========================================================================
  motability_message: {
    type: "likert_grid",
    label: "Motability: Message testing",
    netLabel: "agreement with the message",
    fulltext: "Below are some statements about the Motability Scheme. For each one, please tell us how much you agree or disagree.",
    sidebarCompareSubtitle: "Compare net agreement across all statements, or drill into one.",
    sidebarCompareButton: "Compare all statements",
    sidebarDrillTitle: "Drill into a statement",
    sidebarDrillSubtitle: "Select a statement for individual results.",
    sidebarDrillSubtitleTarget: "Select one statement for targeting.",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    subVariables: [
      "motability_message_help_not_cost",
      "motability_message_independence_work",
      "motability_message_misuse_sustainable",
      "motability_message_support_british_jobs",
      "motability_message_electric_vehicles",
      "motability_message_NEETS",
      "motability_message_supports_wellbeing",
      "motability_message_healthcare",
      "motability_message_freedom_independence",
      // "motability_message_standing_up",    // Wave 4 only — not asked June 2026
      // "motability_message_treasury_deal",  // Wave 4 only — not asked June 2026
    ],
    subLabels: {
      "motability_message_help_not_cost":        "Helping disabled people, not costing taxpayer",
      "motability_message_independence_work":   "Independence to get back to work",
      "motability_message_misuse_sustainable":  "Tackling misuse to be sustainable",
      "motability_message_support_british_jobs": "Supports British jobs and the economy",
      "motability_message_electric_vehicles":   "Helping the switch to electric vehicles",
      "motability_message_NEETS":               "Reducing the number of NEETs",
      "motability_message_supports_wellbeing":  "Supports wellbeing and connection",
      "motability_message_healthcare":          "Easier access to healthcare appointments",
      "motability_message_freedom_independence": "Gives freedom and independence",
      // "motability_message_standing_up":       "Standing up for disabled people",
      // "motability_message_treasury_deal":     "Treasury deal is fair for disabled people",
    },
    subColors: {
      "motability_message_independence_work":   "#1565C0",
      "motability_message_help_not_cost":       "#2E7D32",
      "motability_message_misuse_sustainable":  "#F57C00",
      "motability_message_support_british_jobs": "#7B1FA2",
      "motability_message_electric_vehicles":   "#0097A7",
      "motability_message_NEETS":               "#C62828",
      "motability_message_supports_wellbeing":  "#558B2F",
      "motability_message_healthcare":          "#AD1457",
      "motability_message_freedom_independence": "#4E342E",
      // "motability_message_standing_up":       "#7B1FA2",
      // "motability_message_treasury_deal":     "#0097A7",
    },
    keys: [
      // --- continuing statements (Wave-4 column names, waves 4 + 5) ---
      "motability_message_help_not_cost_strongly_agree_message_help_no",
      "motability_message_help_not_cost_trust_somewhat_agree_message_h",
      "motability_message_help_not_cost_neither_message_help_not_cost",
      "motability_message_help_not_cost_somewhat_disagree_message_help",
      "motability_message_help_not_cost_strong_disagree_message_help_n",
      "motability_message_independence_work_strongly_agree_message_ind",
      "motability_message_independence_work_trust_somewhat_agree_messa",
      "motability_message_independence_work_neither_message_independen",
      "motability_message_independence_work_somewhat_disagree_message_",
      "motability_message_independence_work_strong_disagree_message_in",
      "motability_message_misuse_sustainable_strongly_agree_message_mi",
      "motability_message_misuse_sustainable_trust_somewhat_agree_mess",
      "motability_message_misuse_sustainable_neither_message_misuse_su",
      "motability_message_misuse_sustainable_somewhat_disagree_message",
      "motability_message_misuse_sustainable_strong_disagree_message_m",
      // --- new Wave-5 statements ---
      "motability_message_support_british_jobs_strongly_agree_message_",
      "motability_message_support_british_jobs_somewhat_agree_message_",
      "motability_message_support_british_jobs_neither_message_support",
      "motability_message_support_british_jobs_somewhat_disagree_messa",
      "motability_message_support_british_jobs_strongly_disagree_messa",
      "motability_message_electric_vehicles_strongly_agree_message_ele",
      "motability_message_electric_vehicles_somewhat_agree_message_ele",
      "motability_message_electric_vehicles_neither_message_electric_v",
      "motability_message_electric_vehicles_somewhat_disagree_message_",
      "motability_message_electric_vehicles_strongly_disagree_message_",
      "motability_message_NEETS_strongly_agree_message_NEETS",
      "motability_message_NEETS_somewhat_agree_message_NEETS",
      "motability_message_NEETS_neither_message_NEETS",
      "motability_message_NEETS_somewhat_disagree_message_NEETS",
      "motability_message_NEETS_strongly_disagree_message_NEETS",
      "motability_message_supports_wellbeing_strongly_agree_message_su",
      "motability_message_supports_wellbeing_somewhat_agree_message_su",
      "motability_message_supports_wellbeing_neither_message_supports_",
      "motability_message_supports_wellbeing_somewhat_disagree_message",
      "motability_message_supports_wellbeing_strongly_disagree_message",
      "motability_message_healthcare_strongly_agree_message_healthcare",
      "motability_message_healthcare_somewhat_agree_message_healthcare",
      "motability_message_healthcare_neither_message_healthcare",
      "motability_message_healthcare_somewhat_disagree_message_healthc",
      "motability_message_healthcare_strongly_disagree_message_healthc",
      "motability_message_freedom_independence_strongly_agree_message_",
      "motability_message_freedom_independence_somewhat_agree_message_",
      "motability_message_freedom_independence_neither_message_freedom",
      "motability_message_freedom_independence_somewhat_disagree_messa",
      "motability_message_freedom_independence_strongly_disagree_messa",
      // --- Wave 4 only — not asked June 2026 ---
      // "motability_message_standing_up_strongly_agree_message_standing_",
      // "motability_message_standing_up_trust_somewhat_agree_message_sta",
      // "motability_message_standing_up_neither_message_standing_up",
      // "motability_message_standing_up_somewhat_disagree_message_standi",
      // "motability_message_standing_up_strong_disagree_message_standing",
      // "motability_message_treasury_deal_strongly_agree_message_treasur",
      // "motability_message_treasury_deal_trust_somewhat_agree_message_t",
      // "motability_message_treasury_deal_neither_message_treasury_deal",
      // "motability_message_treasury_deal_somewhat_disagree_message_trea",
      // "motability_message_treasury_deal_strong_disagree_message_treasu",
    ],
    labels: {},
    schema: "tracking",
    waves: [4, 5],
  },
 
  // =========================================================================
  // MOTABILITY MESSAGE TESTING — SUB-VARIABLES (hidden)
  //
  // CONTINUING (waves 4 + 5). Keys unchanged — the Wave-5 Parquet columns were
  // renamed to these Wave-4 names, including the "trust_somewhat_agree" and
  // "strong_disagree" coding artefacts.
  // =========================================================================
  motability_message_help_not_cost: {
    type: "likert",
    hidden: true,
    label: "Message: Helping disabled people, not costing taxpayer",
    fulltext: "The Motability Scheme is helping disabled people whilst not costing the tax payer",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_help_not_cost_strongly_agree_message_help_no",
      "motability_message_help_not_cost_trust_somewhat_agree_message_h",
      "motability_message_help_not_cost_neither_message_help_not_cost",
      "motability_message_help_not_cost_somewhat_disagree_message_help",
      "motability_message_help_not_cost_strong_disagree_message_help_n",
    ],
    labels: {
      "motability_message_help_not_cost_strongly_agree_message_help_no": "Strongly agree",
      "motability_message_help_not_cost_trust_somewhat_agree_message_h": "Somewhat agree",
      "motability_message_help_not_cost_neither_message_help_not_cost":  "Neither agree nor disagree",
      "motability_message_help_not_cost_somewhat_disagree_message_help": "Somewhat disagree",
      "motability_message_help_not_cost_strong_disagree_message_help_n": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_help_not_cost_strongly_agree_message_help_no", "motability_message_help_not_cost_trust_somewhat_agree_message_h"],
      neu: "motability_message_help_not_cost_neither_message_help_not_cost",
      neg: ["motability_message_help_not_cost_somewhat_disagree_message_help", "motability_message_help_not_cost_strong_disagree_message_help_n"],
    },
    schema: "tracking",
    waves: [4, 5],
  },
 
  motability_message_independence_work: {
    type: "likert",
    hidden: true,
    label: "Message: Independence to get back to work",
    fulltext: "The Motability Scheme is giving disabled people independence to get back to work which is good for the economy",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_independence_work_strongly_agree_message_ind",
      "motability_message_independence_work_trust_somewhat_agree_messa",
      "motability_message_independence_work_neither_message_independen",
      "motability_message_independence_work_somewhat_disagree_message_",
      "motability_message_independence_work_strong_disagree_message_in",
    ],
    labels: {
      "motability_message_independence_work_strongly_agree_message_ind": "Strongly agree",
      "motability_message_independence_work_trust_somewhat_agree_messa": "Somewhat agree",
      "motability_message_independence_work_neither_message_independen": "Neither agree nor disagree",
      "motability_message_independence_work_somewhat_disagree_message_": "Somewhat disagree",
      "motability_message_independence_work_strong_disagree_message_in": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_independence_work_strongly_agree_message_ind", "motability_message_independence_work_trust_somewhat_agree_messa"],
      neu: "motability_message_independence_work_neither_message_independen",
      neg: ["motability_message_independence_work_somewhat_disagree_message_", "motability_message_independence_work_strong_disagree_message_in"],
    },
    schema: "tracking",
    waves: [4, 5],
  },
 
  motability_message_misuse_sustainable: {
    type: "likert",
    hidden: true,
    label: "Message: Tackling misuse to be sustainable",
    fulltext: "The Motability Scheme is tackling misuse to make it more sustainable for the future",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_misuse_sustainable_strongly_agree_message_mi",
      "motability_message_misuse_sustainable_trust_somewhat_agree_mess",
      "motability_message_misuse_sustainable_neither_message_misuse_su",
      "motability_message_misuse_sustainable_somewhat_disagree_message",
      "motability_message_misuse_sustainable_strong_disagree_message_m",
    ],
    labels: {
      "motability_message_misuse_sustainable_strongly_agree_message_mi": "Strongly agree",
      "motability_message_misuse_sustainable_trust_somewhat_agree_mess": "Somewhat agree",
      "motability_message_misuse_sustainable_neither_message_misuse_su": "Neither agree nor disagree",
      "motability_message_misuse_sustainable_somewhat_disagree_message": "Somewhat disagree",
      "motability_message_misuse_sustainable_strong_disagree_message_m": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_misuse_sustainable_strongly_agree_message_mi", "motability_message_misuse_sustainable_trust_somewhat_agree_mess"],
      neu: "motability_message_misuse_sustainable_neither_message_misuse_su",
      neg: ["motability_message_misuse_sustainable_somewhat_disagree_message", "motability_message_misuse_sustainable_strong_disagree_message_m"],
    },
    schema: "tracking",
    waves: [4, 5],
  },
 
  // =========================================================================
  // NEW IN WAVE 5 (waves [5])
  // =========================================================================
  motability_message_support_british_jobs: {
    type: "likert",
    hidden: true,
    label: "Message: Supports British jobs and the economy",
    fulltext: "The Motability Scheme supports British jobs and the economy by buying British-made vehicles, supporting the used car market, and creating skilled jobs",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_support_british_jobs_strongly_agree_message_",
      "motability_message_support_british_jobs_somewhat_agree_message_",
      "motability_message_support_british_jobs_neither_message_support",
      "motability_message_support_british_jobs_somewhat_disagree_messa",
      "motability_message_support_british_jobs_strongly_disagree_messa",
    ],
    labels: {
      "motability_message_support_british_jobs_strongly_agree_message_":    "Strongly agree",
      "motability_message_support_british_jobs_somewhat_agree_message_":    "Somewhat agree",
      "motability_message_support_british_jobs_neither_message_support":    "Neither agree nor disagree",
      "motability_message_support_british_jobs_somewhat_disagree_messa":    "Somewhat disagree",
      "motability_message_support_british_jobs_strongly_disagree_messa":    "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_support_british_jobs_strongly_agree_message_", "motability_message_support_british_jobs_somewhat_agree_message_"],
      neu: "motability_message_support_british_jobs_neither_message_support",
      neg: ["motability_message_support_british_jobs_somewhat_disagree_messa", "motability_message_support_british_jobs_strongly_disagree_messa"],
    },
    schema: "tracking",
    waves: [5],
  },
 
  motability_message_electric_vehicles: {
    type: "likert",
    hidden: true,
    label: "Message: Helping the switch to electric vehicles",
    fulltext: "The Motability Scheme helps disabled people switch to electric vehicles by 2032, standing up for customers so that no one is left behind",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_electric_vehicles_strongly_agree_message_ele",
      "motability_message_electric_vehicles_somewhat_agree_message_ele",
      "motability_message_electric_vehicles_neither_message_electric_v",
      "motability_message_electric_vehicles_somewhat_disagree_message_",
      "motability_message_electric_vehicles_strongly_disagree_message_",
    ],
    labels: {
      "motability_message_electric_vehicles_strongly_agree_message_ele": "Strongly agree",
      "motability_message_electric_vehicles_somewhat_agree_message_ele": "Somewhat agree",
      "motability_message_electric_vehicles_neither_message_electric_v": "Neither agree nor disagree",
      "motability_message_electric_vehicles_somewhat_disagree_message_": "Somewhat disagree",
      "motability_message_electric_vehicles_strongly_disagree_message_": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_electric_vehicles_strongly_agree_message_ele", "motability_message_electric_vehicles_somewhat_agree_message_ele"],
      neu: "motability_message_electric_vehicles_neither_message_electric_v",
      neg: ["motability_message_electric_vehicles_somewhat_disagree_message_", "motability_message_electric_vehicles_strongly_disagree_message_"],
    },
    schema: "tracking",
    waves: [5],
  },
 
  motability_message_NEETS: {
    type: "likert",
    hidden: true,
    label: "Message: Reducing the number of NEETs",
    fulltext: "The Motability Scheme helps reduce the number of young people who are not in education, employment, or training (known as \"NEETs\") by helping disabled people get into work, education, and training",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_NEETS_strongly_agree_message_NEETS",
      "motability_message_NEETS_somewhat_agree_message_NEETS",
      "motability_message_NEETS_neither_message_NEETS",
      "motability_message_NEETS_somewhat_disagree_message_NEETS",
      "motability_message_NEETS_strongly_disagree_message_NEETS",
    ],
    labels: {
      "motability_message_NEETS_strongly_agree_message_NEETS":    "Strongly agree",
      "motability_message_NEETS_somewhat_agree_message_NEETS":    "Somewhat agree",
      "motability_message_NEETS_neither_message_NEETS":           "Neither agree nor disagree",
      "motability_message_NEETS_somewhat_disagree_message_NEETS": "Somewhat disagree",
      "motability_message_NEETS_strongly_disagree_message_NEETS": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_NEETS_strongly_agree_message_NEETS", "motability_message_NEETS_somewhat_agree_message_NEETS"],
      neu: "motability_message_NEETS_neither_message_NEETS",
      neg: ["motability_message_NEETS_somewhat_disagree_message_NEETS", "motability_message_NEETS_strongly_disagree_message_NEETS"],
    },
    schema: "tracking",
    waves: [5],
  },
 
  motability_message_supports_wellbeing: {
    type: "likert",
    hidden: true,
    label: "Message: Supports wellbeing and connection",
    fulltext: "The Motability Scheme supports people's wellbeing, helping them feel secure and stay connected to others",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_supports_wellbeing_strongly_agree_message_su",
      "motability_message_supports_wellbeing_somewhat_agree_message_su",
      "motability_message_supports_wellbeing_neither_message_supports_",
      "motability_message_supports_wellbeing_somewhat_disagree_message",
      "motability_message_supports_wellbeing_strongly_disagree_message",
    ],
    labels: {
      "motability_message_supports_wellbeing_strongly_agree_message_su": "Strongly agree",
      "motability_message_supports_wellbeing_somewhat_agree_message_su": "Somewhat agree",
      "motability_message_supports_wellbeing_neither_message_supports_": "Neither agree nor disagree",
      "motability_message_supports_wellbeing_somewhat_disagree_message": "Somewhat disagree",
      "motability_message_supports_wellbeing_strongly_disagree_message": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_supports_wellbeing_strongly_agree_message_su", "motability_message_supports_wellbeing_somewhat_agree_message_su"],
      neu: "motability_message_supports_wellbeing_neither_message_supports_",
      neg: ["motability_message_supports_wellbeing_somewhat_disagree_message", "motability_message_supports_wellbeing_strongly_disagree_message"],
    },
    schema: "tracking",
    waves: [5],
  },
 
  motability_message_healthcare: {
    type: "likert",
    hidden: true,
    label: "Message: Easier access to healthcare appointments",
    fulltext: "The Motability Scheme makes it easier for customers to get to healthcare appointments, meaning fewer missed appointments, less pressure on the NHS, and better health in the long run",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_healthcare_strongly_agree_message_healthcare",
      "motability_message_healthcare_somewhat_agree_message_healthcare",
      "motability_message_healthcare_neither_message_healthcare",
      "motability_message_healthcare_somewhat_disagree_message_healthc",
      "motability_message_healthcare_strongly_disagree_message_healthc",
    ],
    labels: {
      "motability_message_healthcare_strongly_agree_message_healthcare": "Strongly agree",
      "motability_message_healthcare_somewhat_agree_message_healthcare": "Somewhat agree",
      "motability_message_healthcare_neither_message_healthcare":        "Neither agree nor disagree",
      "motability_message_healthcare_somewhat_disagree_message_healthc": "Somewhat disagree",
      "motability_message_healthcare_strongly_disagree_message_healthc": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_healthcare_strongly_agree_message_healthcare", "motability_message_healthcare_somewhat_agree_message_healthcare"],
      neu: "motability_message_healthcare_neither_message_healthcare",
      neg: ["motability_message_healthcare_somewhat_disagree_message_healthc", "motability_message_healthcare_strongly_disagree_message_healthc"],
    },
    schema: "tracking",
    waves: [5],
  },
 
  motability_message_freedom_independence: {
    type: "likert",
    hidden: true,
    label: "Message: Gives freedom and independence",
    fulltext: "The Motability Scheme gives the people who use it freedom and independence",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_freedom_independence_strongly_agree_message_",
      "motability_message_freedom_independence_somewhat_agree_message_",
      "motability_message_freedom_independence_neither_message_freedom",
      "motability_message_freedom_independence_somewhat_disagree_messa",
      "motability_message_freedom_independence_strongly_disagree_messa",
    ],
    labels: {
      "motability_message_freedom_independence_strongly_agree_message_": "Strongly agree",
      "motability_message_freedom_independence_somewhat_agree_message_": "Somewhat agree",
      "motability_message_freedom_independence_neither_message_freedom": "Neither agree nor disagree",
      "motability_message_freedom_independence_somewhat_disagree_messa": "Somewhat disagree",
      "motability_message_freedom_independence_strongly_disagree_messa": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_freedom_independence_strongly_agree_message_", "motability_message_freedom_independence_somewhat_agree_message_"],
      neu: "motability_message_freedom_independence_neither_message_freedom",
      neg: ["motability_message_freedom_independence_somewhat_disagree_messa", "motability_message_freedom_independence_strongly_disagree_messa"],
    },
    schema: "tracking",
    waves: [5],
  },
 
  // =========================================================================
  // WAVE 4 ONLY — not asked in June 2026. Commented out per instruction;
  // uncomment (and restore the grid entries above) to expose Wave-4 results.
  // =========================================================================
  /*
  motability_message_standing_up: {
    type: "likert",
    hidden: true,
    label: "Message: Standing up for disabled people",
    fulltext: "Motability is standing up for disabled people in its negotiations with Government",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_standing_up_strongly_agree_message_standing_",
      "motability_message_standing_up_trust_somewhat_agree_message_sta",
      "motability_message_standing_up_neither_message_standing_up",
      "motability_message_standing_up_somewhat_disagree_message_standi",
      "motability_message_standing_up_strong_disagree_message_standing",
    ],
    labels: {
      "motability_message_standing_up_strongly_agree_message_standing_": "Strongly agree",
      "motability_message_standing_up_trust_somewhat_agree_message_sta": "Somewhat agree",
      "motability_message_standing_up_neither_message_standing_up":      "Neither agree nor disagree",
      "motability_message_standing_up_somewhat_disagree_message_standi": "Somewhat disagree",
      "motability_message_standing_up_strong_disagree_message_standing": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_standing_up_strongly_agree_message_standing_", "motability_message_standing_up_trust_somewhat_agree_message_sta"],
      neu: "motability_message_standing_up_neither_message_standing_up",
      neg: ["motability_message_standing_up_somewhat_disagree_message_standi", "motability_message_standing_up_strong_disagree_message_standing"],
    },
    schema: "tracking",
    waves: [4],
  },
 
  motability_message_treasury_deal: {
    type: "likert",
    hidden: true,
    label: "Message: Treasury deal is fair for disabled people",
    fulltext: "The deal Motability has agreed with the Treasury is a fair one for disabled people",
    client: ["motability-operations", "stack-data-strategy"],
    category: "motability",
    keys: [
      "motability_message_treasury_deal_strongly_agree_message_treasur",
      "motability_message_treasury_deal_trust_somewhat_agree_message_t",
      "motability_message_treasury_deal_neither_message_treasury_deal",
      "motability_message_treasury_deal_somewhat_disagree_message_trea",
      "motability_message_treasury_deal_strong_disagree_message_treasu",
    ],
    labels: {
      "motability_message_treasury_deal_strongly_agree_message_treasur": "Strongly agree",
      "motability_message_treasury_deal_trust_somewhat_agree_message_t": "Somewhat agree",
      "motability_message_treasury_deal_neither_message_treasury_deal":  "Neither agree nor disagree",
      "motability_message_treasury_deal_somewhat_disagree_message_trea": "Somewhat disagree",
      "motability_message_treasury_deal_strong_disagree_message_treasu": "Strongly disagree",
    },
    polarity: {
      pos: ["motability_message_treasury_deal_strongly_agree_message_treasur", "motability_message_treasury_deal_trust_somewhat_agree_message_t"],
      neu: "motability_message_treasury_deal_neither_message_treasury_deal",
      neg: ["motability_message_treasury_deal_somewhat_disagree_message_trea", "motability_message_treasury_deal_strong_disagree_message_treasu"],
    },
    schema: "tracking",
    waves: [4],
  },
  */
};


